import { memo } from "react";
import type { SvgProps } from "react-native-svg";
import Svg, { Path } from "react-native-svg";

const SvgCheckmark = (props: SvgProps) => (
  <Svg width={16} height={17} fill="none" {...props}>
    <Path
      stroke={props.color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
      d="m3 8 3 3 7-7"
    />
  </Svg>
);
const Memo = memo(SvgCheckmark);
export default Memo;
